<template>
  <v-layout id="statistic" fill-height>
    <v-row style="text-align:center">
      <v-col cols="12" md="12">
        <div class="statistic-desc mobile" v-if="isMobile()">시민들이 에브리바이크와 함께</div>
        <div class="statistic-desc" v-else>시민들이 에브리바이크와 함께</div>
      </v-col>
      <v-col cols="12" md="4">
        <div>
          <img src="../assets/earth.png" alt="Distance image" class="statistic-image-mobile" v-if="isMobile()"/>
          <img src="../assets/earth.png" alt="Distance image" class="statistic-image" v-else/>
        </div>
        
        <div class="statistic-value mobile" v-if="isMobile()">
          누적 이동거리
          <number
              :to="statistics.distance"
              :format="theFormat"
          ></number>
          km
        </div>
        <div class="statistic-value" v-else>
          누적 이동거리
          <number
              :to="statistics.distance"
              :format="theFormat"
          ></number>
          km
        </div>
        <div class="statistic-info mobile" v-if="isMobile()">
          지구 약
          <number 
            :to="statistics.distance/40000"
            :format="theFormat"
          ></number>
          바퀴
        </div>
        <div class="statistic-info" v-else>
          지구 약
          <number 
            :to="statistics.distance/40000"
            :format="theFormat"
          ></number>
          바퀴
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div>
          <img src="../assets/hamburger.png" alt="Calorie image" class="statistic-image-mobile" v-if="isMobile()"/>
          <img src="../assets/hamburger.png" alt="Calorie image" class="statistic-image" v-else/>
        </div>
        <div class="statistic-value mobile" v-if="isMobile()">
          누적 소모 칼로리
          <number
              :to="statistics.calorie"
              :format="theFormat"
          ></number>
          kcal
        </div>
        <div class="statistic-value" v-else>
          누적 소모 칼로리
          <number
              :to="statistics.calorie"
              :format="theFormat"
          ></number>
          kcal
        </div>
        <div class="statistic-info mobile" v-if="isMobile()">
          햄버거 약
          <number
            :to="statistics.calorie/500"
            :format="theFormat"
          ></number>
          개
        </div>
        <div class="statistic-info" v-else>
          햄버거 약
          <number
            :to="statistics.calorie/500"
            :format="theFormat"
          ></number>
          개
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div>
          <img src="../assets/car.png" alt="Carbon image" class="statistic-image-mobile" v-if="isMobile()"/>
          <img src="../assets/car.png" alt="Carbon image" class="statistic-image" v-else/>
        </div>
        <div class="statistic-value mobile" v-if="isMobile()">
          절감한 탄소 발생량
          <number
              :to="statistics.carbon"
              :format="theFormat"
          ></number>
          kg
        </div>
        <div class="statistic-value" v-else>
          절감한 탄소 발생량
          <number
              :to="statistics.carbon"
              :format="theFormat"
          ></number>
          kg
        </div>
        <div class="statistic-info mobile" v-if="isMobile()">
          자동차 약
          <number
            :to="statistics.carbon/2100"
            :format="theFormat"
          ></number>
          대 연간 배출량
        </div>
        <div class="statistic-info" v-else>
          자동차 약
          <number
            :to="statistics.carbon/2100"
            :format="theFormat"
          ></number>
          대 연간 배출량
        </div>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import axios from "axios"

export default {
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    fetchTotalTrip() {
      axios
          .get('https://api.everybike.net/servers/v1/total-trip-info')
          .then(response => {
            this.info = response.data;
            if (response.status === 200) {
              const total_meter = response.data.total_distance
              const total_calories = response.data.total_calories
              this.statistics.distance = parseInt(total_meter / 1000)
              this.statistics.calorie = parseInt(total_calories)
              this.statistics.carbon = parseInt(total_meter/1000 * 0.241348)
            }
          }).catch((e) => {
        if (!e.response) {
          // network error
        } else {
          //do nothing
        }
      })
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    theFormat(number) {
      return String(number.toFixed(0)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  data: () => ({
        statistics: {
          distance: "0",
          calorie: "0",
          carbon: "0",
        },
        timer: ''
      }

  ),
  mounted() {
    this.fetchTotalTrip();
  },
  created() {
    this.timer = setInterval(this.fetchTotalTrip, 5000);
  },
  beforeDestroy() {
    this.cancelAutoUpdate();
  }

}

</script>

<style lang="scss">
#statistic {
  padding-top: 32px;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #777777;

  a {
    /*text-decoration: none!important;*/
    text-underline: #777777;;
    color: #777777;
  }

  @media screen and (max-width: 1280px) {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
  }
}

.statistic {
  &-desc {
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    font-size: 40px;
    color: #0173c1;
    margin-bottom: 20px;
    &.mobile {
      font-size: 20px;
    }
  }

  &-value {
    font-size: 22px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #0173c1;
    margin-bottom: 4px;
    &.mobile{
      font-size: 17px
    }
  }

  &-info {
    font-size: 34px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #0173c1;
    margin-bottom: 30px;
    &.mobile{
      font-size: 28px;
    }
  }
}
.statistic-image {
  width: 84px;
  height: 84px;
  &-mobile {
    width: 74px;
    height: 74px;
  }
}
</style>